module.exports = __webpack_public_path__ + "static/media/escudo-uchile-horizontal-blanco-fondo-transp.46b502d4.png";